/**
 * Komponente zum Anzeigen einer ansichtsübergreifenden Benachrichtigungsleiste mit Hinweis aus Back-End
 */

import * as React from 'react';
import { Alert } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { action } from 'mobx';

import { bind, inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';

@observer
export default class Benachrichtigung extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;

  @action setBenachrichtigung(value: string) {
    this.uiStore.benachrichtigung = value;
  }

  @bind @action closeBenachrichtigung() {
    this.setBenachrichtigung('');
  }

  render() {
    return (
      <div>
        {this.uiStore.isLoggedIn && this.uiStore.benachrichtigung && <Alert bsStyle="warning" onDismiss={this.closeBenachrichtigung} style={{textAlign: 'center'}}><b>Hinweis:</b> {this.uiStore.benachrichtigung}</Alert>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Benachrichtigung.tsx